import CMX from '../../api';
import {
  YEAR_RECAP_FETCH,
  YEAR_RECAP_FETCH_SUCCESS,
  YEAR_RECAP_FETCH_ERROR,
} from '../types';

export const fetchYearRecap = () => async dispatch => {
  dispatch({ type: YEAR_RECAP_FETCH });

  try {
    const response = await CMX.get('/me/yearRecap');
    dispatch({
      type: YEAR_RECAP_FETCH_SUCCESS,
      data: response.data || response,
    });
  } catch (error) {
    dispatch({
      type: YEAR_RECAP_FETCH_ERROR,
      error: error.message || 'Error al cargar el resumen del año',
    });
  }
};

